module.exports = "/img/_/_/_/assets/images/creeper/battle/common//6.jpg?0eed8f25aa955d95a6a13aaf0273f025";